export default __webpack_public_path__ + "static/media/Gilroy-Regular.319e0b95.ttf";